<template>
  <footer id="footer">
    <div class="container">
      <div class="footer-shell banner-slab">
        <div class="footer-grid">
          <div class="footer-copy">
            <div class="section-kicker">7x24小时售后支持</div>
            <div class="section-title">北海带恩为会员权益业务提供资源、系统与运营的一站式支持。</div>
            <div class="section-subtitle">
              全国7×24小时客服热线，多对一团队服务，帮助客户更快落地会员权益项目。
            </div>
            <div class="section-actions">
              <router-link to="/software" class="site-btn site-btn--primary">查看产品</router-link>
              <router-link to="/contactus" class="site-btn site-btn--ghost">联系咨询</router-link>
            </div>
          </div>

          <div class="footer-info-grid">
            <div class="soft-card footer-info-item">
              <div class="footer-label">7x24小时售后支持</div>
              <div class="footer-value">全国7×24小时客服热线</div>
            </div>
            <div class="soft-card footer-info-item">
              <div class="footer-label">性能安全</div>
              <div class="footer-value">30,000+ 每秒访问处理经验</div>
            </div>
            <div class="soft-card footer-info-item">
              <div class="footer-label">增值服务</div>
              <div class="footer-value">自助发卡系统，自主设计/渠道推广</div>
            </div>
            <div class="soft-card footer-info-item">
              <div class="footer-label">多对一团队服务</div>
              <div class="footer-value">商务运营团队多对一提供服务</div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <div class="footer-brand">
          <span class="brand-mini"></span>
          <div>
            <strong>北海带恩</strong>
            <p>会员权益解决方案供应商</p>
          </div>
        </div>
        <div class="footer-copyline">
          © 2026 北海带恩.
          <a
            class="footer-copyline-link"
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
          >桂ICP备2026008366号-1</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped>
#footer {
  padding: 28px 0 36px;
}

.footer-shell {
  padding: 34px;
}

.footer-grid {
  display: grid;
  grid-template-columns: 1.2fr 0.95fr;
  gap: 24px;
  align-items: stretch;
}

.footer-copy .section-title {
  max-width: 640px;
  color: #fff;
}

.footer-info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.footer-info-item {
  min-height: 112px;
}

.footer-label {
  color: rgba(255, 255, 255, 0.72);
  font-size: 13px;
}

.footer-value {
  margin-top: 12px;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.5;
}

.footer-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 6px 0;
  color: var(--muted);
}

.footer-brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.brand-mini {
  width: 34px;
  height: 34px;
  border-radius: 12px;
  background: linear-gradient(135deg, #ff7a59 0%, #10b8a6 100%);
  box-shadow: 0 10px 26px rgba(255, 122, 89, 0.28);
}

.footer-brand strong {
  color: var(--text);
  font-size: 15px;
}

.footer-brand p {
  margin-top: 4px;
  font-size: 12px;
}

.footer-copyline {
  text-align: right;
  font-size: 13px;
  line-height: 1.6;
}

.footer-copyline-link {
  color: inherit;
  text-decoration: none;
}

.footer-copyline-link:hover {
  text-decoration: underline;
}

@media screen and (max-width: 991px) {
  .footer-shell {
    padding: 24px;
  }

  .footer-grid {
    grid-template-columns: 1fr;
  }
}

@media screen and (max-width: 767px) {
  #footer {
    padding-bottom: 24px;
  }

  .footer-info-grid {
    grid-template-columns: 1fr;
  }

  .footer-bottom {
    flex-direction: column;
    align-items: flex-start;
  }

  .footer-copyline {
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue